<template>
  <v-row justify="center">
    <v-dialog :value="value" @input="vaciar()" max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">{{localization.importarSolicitud}}</span>
        </v-card-title>
        <v-card-text>
          <v-container v-if="!enviado">
            <v-form v-model="valid" id="valid" ref="form">
              <v-row>
                <v-col cols="12" sm="12">
                    <v-file-input :label="localization.seleccionarArchivoExcel" filled
                    v-model="fichero" id="fichero" prepend-icon="attach_file"
                    accept="application/vnd.ms-excel"
                    :rules="[fichero ? rules.validarFormatoExcel(fichero.type) : null]"
                    truncate-length="100"
                    ></v-file-input>
                </v-col>
              </v-row>
            </v-form>
            <v-row>
              <v-col cols="12" sm="12">
                <v-btn @click="descargaPlantilla()" color="primary" class="mr-2" :disabled="loading">{{localization.plantilla}}</v-btn>
                <v-btn @click="descargaFormato()" color="primary" :disabled="loading">{{localization.formato}}</v-btn>
              </v-col>
            </v-row>
          </v-container>
          <v-container v-if="enviado">
            <v-tabs
              grow color="primary"
              background-color="transparent"
              class="transparentTabs"
            >
              <v-tab>
              {{localization.solicitudesImportadas}}
              </v-tab>
              <v-tab>
              {{localization.solicitudesNoImportadas}}
              </v-tab>
              <v-tab-item>
                <v-container v-show="incidenciasOK">
                  <v-row>
                    <v-data-table :headers="headersOK" :items="listaIncidenciasOK"
                      item-key="id" style="width:100%"
                      :footer-props="{
                        'items-per-page-options': [5, 10, 15, 20],
                        'items-per-page-text': $t('filasPorPagina'),
                      }"
                      loading-text="Cargando datos...">
                      <template
                        v-slot:body="{ items }">
                        <tbody>
                          <tr v-for="item in items" :key="item.id">
                            <td style="max-width: 80px;" class="text-xs-center">{{ item.PROMOCIÓN }}</td>
                            <td style="max-width: 150px;" class="text-xs-center">{{ item.INMUEBLE }}</td>
                            <td style="max-width: 150px;" class="text-xs-center">{{ mostrarIdiomaTipoVisita(item.TIPO) }}</td>
                            <td style="max-width: 150px;" class="text-xs-center">{{ ((item.FECHA_DE_ENTRADA === "") ? "" : formatDate(item.FECHA_DE_ENTRADA) ) }}</td>
                            <td style="max-width: 150px;" class="text-xs-center">{{ mostrarIdiomaEstado(item.ESTADO) }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-data-table>
                  </v-row>
                  <v-btn color="primary" :key="1" border="primary" class="ma-1"
                    dark style="min-width: 230px !important; max-width: 230px;"
                    @click="descargarInformeOK()"
                    :disabled="loading">
                    {{localization.descargarInforme}}
                  </v-btn>
                </v-container>
              </v-tab-item>
              <v-tab-item>
                <v-container v-show="incidenciasKO">
                <v-row>
                  <v-data-table :headers="headersKO" :items="listaIncidenciasKO"
                    item-key="id"  style="width:100%"
                    :footer-props="{
                      'items-per-page-options': [5, 10, 15, 20],
                      'items-per-page-text': $t('filasPorPagina'),
                    }"
                    loading-text="Cargando datos...">
                    <template
                      v-slot:body="{ items }">
                      <tbody>
                        <tr v-for="item in items" :key="item.id">
                          <td style="max-width: 80px;" class="text-xs-center">{{ item.PROMOCIÓN }}</td>
                          <td style="max-width: 150px;" class="text-xs-center">{{ item.INMUEBLE }}</td>
                          <td style="max-width: 150px;" class="text-xs-center">{{ mostrarIdiomaTipoVisita(item.TIPO) }}</td>
                          <td style="max-width: 150px;" class="text-xs-center">{{ ((item.FECHA_DE_ENTRADA === "") ? "" : formatDate(item.FECHA_DE_ENTRADA) ) }}</td>
                          <td style="max-width: 150px;" class="text-xs-center">{{ mostrarIdiomaEstado(item.ESTADO) }}</td>
                          <td style="max-width: 150px;" class="text-xs-center">{{ item.ERROR }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-data-table>
                </v-row>
                <v-btn color="primary" :key="1" border="primary" class="ma-1"
                    dark style="min-width: 230px !important; max-width: 230px;"
                    @click="descargarInformeKO()"
                    :disabled="loading">
                    {{localization.descargarInforme}}
                  </v-btn>
              </v-container>
              </v-tab-item>
            </v-tabs>
          </v-container>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
            <v-btn color="primary" @click.native="enviado ? $emit('reload') : null; vaciar(); $emit('input');">{{localization.cerrar}}</v-btn>
            <v-btn color="primary" @click.native="enviar()" :disabled="loading" v-if="!enviado">{{localization.importar}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import rulesMixin from '@/components/generic/rules.js'

export default {
  mixins: [rulesMixin],
  props: {
    value: Boolean,
    singleItem: Array
  },
  data () {
    return {
      fichero: null,
      enviado: false,
      incidenciasOK: false,
      incidenciasKO: false,
      listaIncidenciasOK: [],
      listaIncidenciasKO: [],
      informeOK: [],
      informeKO: [],
      loading: false,
      valid: true,
      credentials: {}
    }
  },
  computed: {
    headersOK () {
      return [
        { text: this.$t('formImportarIncidencias.promocion'), sortable: true, value: 'PROMOCIÓN', align: 'center' },
        { text: this.$t('formImportarIncidencias.inmueble'), value: 'INMUEBLE', sortable: true, align: 'center' },
        { text: this.$t('formImportarIncidencias.tipoIncidencia'), value: 'TIPO', sortable: true, align: 'center' },
        { text: this.$t('formImportarIncidencias.fechaEntrada'), value: 'FECHA_DE_ENTRADA', sortable: true, align: 'center' },
        { text: this.$t('formImportarIncidencias.estado'), value: 'ESTADO', sortable: true, align: 'center' }
      ]
    },
    headersKO () {
      return [
        { text: this.$t('formImportarIncidencias.promocion'), sortable: true, value: 'PROMOCIÓN', align: 'center' },
        { text: this.$t('formImportarIncidencias.inmueble'), value: 'INMUEBLE', sortable: true, align: 'center' },
        { text: this.$t('formImportarIncidencias.tipoIncidencia'), value: 'TIPO', sortable: true, align: 'center' },
        { text: this.$t('formImportarIncidencias.fechaEntrada'), value: 'FECHA_DE_ENTRADA', sortable: true, align: 'center' },
        { text: this.$t('formImportarIncidencias.estado'), value: 'ESTADO', sortable: true, align: 'center' },
        { text: this.$t('formImportarIncidencias.mensaje'), value: 'MENSAJE', sortable: true, align: 'center' }
      ]
    },
    localization () {
      return this.$t('formImportarIncidencias')
    },
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      realizarImportacion: 'incidencias/realizarImportacion',
      getRootState: 'gestion/getRootState'
    }),
    descargaPlantilla () {
      location.href = './plantillas/Plantilla-importacion-incidencias-Posventa.xls'
    },
    async descargaFormato () {
      const prueba = await this.getRootState()
      this.credentials = prueba
      if(this.credentials.motor === 'SIN_BD')
      {
        location.href = './plantillas/Formato-importacion-incidencias-PosventaSinBo.xlsx'
      } else {
        location.href = './plantillas/Formato-importacion-incidencias-Posventa.xlsx'
      }
    },
    formatDate (dateToFormat) {
      return moment(dateToFormat, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    mostrarIdiomaEstado (item) {
      var estados = this.$store.state.incidencias.estados
      var estado = estados.find( o => o.name === item) 
      return estado !== undefined ? estado.translates[this.usuario.idioma] : ''
    },
    mostrarIdiomaTipoVisita (item) {
      var tiposVisita = this.$store.state.incidencias.tipoVisita
      var tipoVisita = tiposVisita.find( o => o.name === item || o.code === item) 
      
      return tipoVisita !== undefined ? tipoVisita.translates[this.usuario.idioma] : ''
    },
    enviar () {
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({ texto: this.$t('seleccioneArchivoCorrecto'), color: 'error' })
      } else {
        if (this.fichero !== null) {
          try {
            this.loading = true

            var loader = this.$loading.show({
              // Optional parameters
              container: this.fullPage ? null : this.$refs.formContainer,
              canCancel: false
            })

            const file = this.fichero
            const nombreFichero = file.name
            const tipoFichero = file.type
            var reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = async () => {
              this.imageBase64 = reader.result
              const arrImageSplit = this.imageBase64.split(',')
              const values = {
                name: nombreFichero,
                type: tipoFichero,
                file_base64: arrImageSplit[1]
              }
              await this.realizarImportacion(values)
                .then((response) => {
                  this.enviado = true
                  if (response.informeOK && response.incidenciasOK.length > 0) {
                    this.incidenciasOK = true
                    this.listaIncidenciasOK = response.incidenciasOK
                    this.informeOK = response.informeOK
                  }
                  if (response.informeNOK && response.incidenciasNOK.length > 0) {
                    this.incidenciasKO = true
                    this.listaIncidenciasKO = response.incidenciasNOK
                    this.informeKO = response.informeNOK
                  }

                  if(response.informeNOK && response.incidenciasNOK.length > 0) {
                    this.addAlert({ texto: this.$t('incidencias_no_importadas'), color: 'error' })
                  }
                  else {
                    this.addAlert({ texto: this.$t('importacion_exitosa'), color: 'success' })
                  }

                  loader.hide()
                  this.loading = false
                })
                .catch((response) => {

                  let mensaje = response.message;
                  if(this.usuario.idioma === 'eus') {
                    mensaje = mensaje.replace('Campo cabecera ', 'Ez da aurkitu ')
                    mensaje = mensaje.replace(' no encontrado', ' goiburuko eremua')

                    mensaje = mensaje.replace('La longitud del campo ', '')
                    mensaje = mensaje.replace('es mayor que el especificado en la plantilla de formato', 'eremuaren luzera formatuan zehaztutakoa baino handiagoa da')

                  } else if (this.usuario.idioma === 'eng') {
                    mensaje = mensaje.replace('Campo cabecera ', 'Field ')
                    mensaje = mensaje.replace(' no encontrado', ' not found')
                    
                    mensaje = mensaje.replace('La longitud del campo ', 'The length of the  ')
                    mensaje = mensaje.replace('es mayor que el especificado en la plantilla de formato', 'field is greater than that specified in the format')

                  }
                  this.addAlert({ texto: mensaje, color: 'error' })
                  loader.hide()
                  this.loading = false
                })
            }
          } catch (error) {
            this.addAlert({ texto: this.$t('errorProducido'), color: 'error' })
          }

        }
      }

    },
    descargarInformeOK () {
      var csvString = atob(this.informeOK.file_base64)
      var universalBOM = "\uFEFF";
      var a = window.document.createElement('a');
      a.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM+csvString));
      a.setAttribute('download', this.informeOK.name);
      window.document.body.appendChild(a);
      a.click()
      window.document.body.removeChild(a)
    },
    descargarInformeKO () {
      var csvString = atob(this.informeKO.file_base64)
      var universalBOM = "\uFEFF";
      var a = window.document.createElement('a');
      a.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent(universalBOM+csvString));
      a.setAttribute('download', this.informeKO.name);
      window.document.body.appendChild(a);
      a.click()
      window.document.body.removeChild(a)
    },
    vaciar () {
      this.fichero = null
      this.enviado = false
      this.incidenciasOK = false
      this.incidenciasKO = false
      this.listaIncidenciasOK = []
      this.listaIncidenciasKO = []
      this.informeOK = []
      this.informeKO = []
      this.$emit('input')
    }
  }
}
</script>

<style scoped>

</style>
